module.exports = __webpack_public_path__ + "img/vende-tu-carro.fff116bd.webp";